/**
 * Design Tokens for Weidner Apartment Homes Rise Theme
 * 
 * Extends the base rise theme tokens with Weidner Apartment Homes Rise branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-rise/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Weidner Apartment Homes Rise brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Header/footer chrome uses primary; CTAs and gold accents use secondary.
    primary: '#000000',
    secondary: '#B28C59',
    textOnPrimary: '#FFFFFF',
    textOnSecondary: '#FFFFFF',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Weidner Apartment Homes Rise typography - customize these
    // heading: '"Your Heading Font", serif',
    // body: '"Your Body Font", sans-serif',
  },
};

export default tokens;
